export const parametertypeConstants = {
    GETALL_REQUEST: 'PARAMETERTYPE_GETALL_REQUEST',
    GETALL_SUCCESS: 'PARAMETERTYPE_GETALL_SUCCESS',
    GETALL_FAILURE: 'PARAMETERTYPE_GETALL_FAILURE',

    DELETE_REQUEST: 'PARAMETERTYPE_DELETE_REQUEST',
    DELETE_SUCCESS: 'PARAMETERTYPE_DELETE_SUCCESS',
    DELETE_FAILURE: 'PARAMETERTYPE_DELETE_FAILURE'
};
